export const convertTransactionAmount = (amount: number) => {
  return amount * 100;
};
